let previousSavings = 0

const updateCartAttributes = (data) => {
  const attributes = { checkout_savings: '' }
  if (
    data.value !== null &&
    !isNaN(data.value) &&
    data.value > 0
  ) attributes.checkout_savings = data.text

  return fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ attributes })
  })
  .catch((error) => {
    console.error('Error updating cart attributes:', error)
  })
}

const parseCurrency = (value) => {
  const pattern = /[\s]*[^\d]*([\d,]*\.\d{1,2})|([\d,]+)/
  const match = value.match(pattern)
  if (!match) return null
  const numberString = (match[1] || match[2]).replace(/,/g, '')
  return parseFloat(numberString)
}

const getSavings = () => {
  const data = { value: null, text: '' }
  const discountTotalEl = document.querySelector('.discounts-total__value')
  if (!discountTotalEl) return data
  data.value = parseCurrency(discountTotalEl.textContent)
  data.text = discountTotalEl.textContent.trim().replace(' ', '')
  return data
}

window.handleSectionPayload = (section) => {
  const data = { value: null, text: '' }
  const parser = new DOMParser()
  const doc = parser.parseFromString(section, 'text/html')
  const totalDiscountEl = doc.querySelector('.total-discount')
  data.value = parseCurrency(totalDiscountEl.textContent)
  data.text = totalDiscountEl.textContent.trim().replace(' ', '')
  return updateCartAttributes(data)
}

const onCartChange = () => {
  const data = getSavings()
  if (data.value === previousSavings) return
  previousSavings = data.value
  updateCartAttributes(data)
}

const observeCartChange = () => {
  const targetNode = document.querySelector('#cart-icon-bubble')
  const observer = new MutationObserver(() => {
    setTimeout(() => { onCartChange() }, 1000)
  })
  observer.observe(targetNode, {
    childList: true,
  })
}

onCartChange()
observeCartChange()